import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as consts from '../../const';
import { ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { hideModal } from '../../actions/actions';
import { Button } from 'tc-client-common';

import {
  RESPONSES_ADD_REASON,
  RESPONSES_REASON_FOR_REMOVE,
  RESPONSES_NEW_BIOSAMPLE_CODE,
  RESPONSES_ADD_NEW_BISAMPLE_CODE,
  RESPONSES_REASON_FOR_UPDATE,
  RESPONSES_SAVE_ERROR,
  RESPONSES_UNIUE_ID_ERROR
} from '../../const';

import { UNIQUE_ID_ERROR_STATUS_CODE } from './constants';

const RemoveBiosampleCodeModalComponent = ({ hideModal, onSave }) => {
  const [reason, updateReason] = useState('');
  const [error, setError] = useState(null);

  // onReasonChange :: input event E => E -> ()
  const onReasonChange = (event) => {
    setError(null);
    updateReason(event.target.value);
  };

  // onSubmit :: form submit event E => E -> ()
  const onSubmit = (event) => {
    event.preventDefault();
    setError(null);

    onSave({ reason })
      .then(() => {
        hideModal();
      })
      .catch((err) => {
        if (err.response && err.response.status === UNIQUE_ID_ERROR_STATUS_CODE) {
          setError(RESPONSES_UNIUE_ID_ERROR);
        } else {
          setError(RESPONSES_SAVE_ERROR);
        }
      });
  };

  return (
    <div id="remove-biosample-code-modal">
      {error && <div className="responses-component-error">{error}</div>}
      <div>
        <Grid id="remove-biosample-code-grid" fluid>
          <Form id="remove-biosample-code-form" onSubmit={onSubmit}>
            <Row>
              <FormGroup>
                <ControlLabel>{RESPONSES_REASON_FOR_REMOVE}</ControlLabel>
                <FormControl
                  componentClass="textarea"
                  id="removeBiosampleCodeReasonInput"
                  type="text"
                  required
                  value={reason}
                  onChange={onReasonChange}
                  placeholder={RESPONSES_ADD_REASON}
                />
              </FormGroup>
            </Row>

            <div className="edit-modal-footer">
              <hr className="edit-modal-divider" />
              <Button
                id="remove-biosample-code-cancel-button"
                type="reset"
                theme="default large-button"
                label={consts.CANCEL_BTN}
                handleClick={hideModal}
              />
              <Button
                id="remove-biosample-code-save-button"
                type="submit"
                theme="active large-button"
                disabled={reason.trim() === ''}
                label={consts.DELETE_BTN}
              />
            </div>
          </Form>
        </Grid>
      </div>
    </div>
  );
};

RemoveBiosampleCodeModalComponent.propTypes = {
  hideModal: PropTypes.func,
  onSave: PropTypes.func
};

const UpdateBiosampleCodeModalComponent = ({ hideModal, onSave }) => {
  const [reason, updateReason] = useState('');
  const [newValue, updateNewValue] = useState('');
  const [error, setError] = useState(null);

  // onReasonChange :: input event E => E -> ()
  const onReasonChange = (event) => {
    setError(null);
    updateReason(event.target.value);
  };

  // onObjectIdChange :: input event E => E -> ()
  const onObjectIdChange = (event) => {
    setError(null);
    updateNewValue(event.target.value);
  };

  // onSubmit :: form submit event E => E -> ()
  const onSubmit = (event) => {
    event.preventDefault();
    setError(null);

    onSave({ reason, biosampleCode: newValue.trim() })
      .then(() => {
        hideModal();
      })
      .catch((err) => {
        if (err.response && err.response.status === UNIQUE_ID_ERROR_STATUS_CODE) {
          setError(RESPONSES_UNIUE_ID_ERROR);
        } else {
          setError(RESPONSES_SAVE_ERROR);
        }
      });
  };

  return (
    <div id="update-biosample-code-modal">
      {error && <div className="responses-component-error">{error}</div>}
      <div>
        <Grid id="update-biosample-code-grid" fluid>
          <Form id="update-biosample-code-form" onSubmit={onSubmit}>
            <Row>
              <FormGroup>
                <ControlLabel>{RESPONSES_NEW_BIOSAMPLE_CODE}</ControlLabel>
                <FormControl
                  id="newBiosampleCodeInput"
                  type="text"
                  required
                  value={newValue}
                  onChange={onObjectIdChange}
                  placeholder={RESPONSES_ADD_NEW_BISAMPLE_CODE}
                  maxLength="255"
                />
              </FormGroup>
            </Row>
            <Row>
              <FormGroup>
                <ControlLabel>{RESPONSES_REASON_FOR_UPDATE}</ControlLabel>
                <FormControl
                  componentClass="textarea"
                  id="newBiosampleCodeReasonInput"
                  type="text"
                  required
                  value={reason}
                  onChange={onReasonChange}
                  placeholder={RESPONSES_ADD_REASON}
                />
              </FormGroup>
            </Row>

            <div className="edit-modal-footer">
              <hr className="edit-modal-divider" />
              <Button
                id="update-biosample-code-cancel-button"
                type="reset"
                theme="default large-button"
                handleClick={hideModal}
                label={consts.CANCEL_BTN}
              />
              <Button
                id="update-biosample-code-save-button"
                type="submit"
                theme="active large-button"
                disabled={newValue.trim() === '' || reason.trim() === ''}
                label={consts.SAVE_BTN}
              />
            </div>
          </Form>
        </Grid>
      </div>
    </div>
  );
};

UpdateBiosampleCodeModalComponent.propTypes = {
  hideModal: PropTypes.func,
  onSave: PropTypes.func
};

const RemoveBiosampleCodeModal = connect(null, (dispatch) => ({ hideModal: () => dispatch(hideModal()) }))(
  RemoveBiosampleCodeModalComponent
);

const UpdateBiosampleCodeModal = connect(null, (dispatch) => ({ hideModal: () => dispatch(hideModal()) }))(
  UpdateBiosampleCodeModalComponent
);

export { RemoveBiosampleCodeModal, UpdateBiosampleCodeModal };
